<template>
  <div class="row">
    <div class="col-sm-7">
      <AlloCard
        v-if="client.phone && !client.deletedAt"
        :can-view="hasPermission($store.state.user, 'CLIENTS_RINGOVER_VISUALIZATION')"
        :email="client.email"
        onlyCommercial
      />
    </div>

    <div class="col-sm-5">
      <ClientLogCard :client="client" />
    </div>
  </div>
</template>

<script>
import AlloCard from "@/components/utils/AlloCard.vue";
import ClientLogCard from "@/components/client/ClientLogCard";

export default {
  components: {
    AlloCard,
    ClientLogCard,
  },

  props: {
    client: {
      type: Object,
      required: true,
    },
  },

  methods: {
    async edit({ name, value }) {
      this.$emit("edit", { name, value });
    },
  },
};
</script>
